import { resolveApiDomain } from "nazare-ui/utils";

type PlatformApiEnvironment = Record<string, string | undefined>;

export function resolveBffDomain(
  appUrl = window.location.origin,
  env = import.meta.env as unknown as PlatformApiEnvironment,
): string {
  const dedicated = env.VITE_NAZARE_API_DOMAIN__BFF;
  if (dedicated) return dedicated.replace(/\/$/, "");

  return resolveApiDomain(appUrl, env.VITE_NAZARE_API_DOMAIN);
}
